import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login/',
    method: 'POST',
    data
  })
}

export function getMe(){
  return request({
    url: '/user/me/',
    method:'GET'
  })
}

export function logout() {
  return request({
    url: '/user/logout/',
    method: 'POST'
  })
}
export function change_password(data) {
  return request({
    url: '/user/change_password/',
    method: 'POST',
    data
  })
}
//add
export function register (data){
  return request({
    url: '/user/register/',
    method: 'POST',
    data
  })
}
//upate
export function updateProfile(data) {
  return request({
    url: '/user/update_profile/',
    method: 'POST',
    data
  })
}
export function updateAgentInfo(data) {
  return request({
    url: '/user/update_agentinfo/',
    method: 'POST',
    data
  })
}
export function updateOemInfo(data) {
  return request({
    url: '/user/update_oeminfo/',
    method: 'POST',
    data
  })
}
export function oem() {
  return request({
    url: '/user/oem/',
    method: 'GET'
  })
}
export function check_oem(rid) {
  return request({
    url: '/user/check_oem/',
    method: 'POST',
    data:{rid:rid}
  })
}

export function check_price() {
  return request({
    url: '/user/check_price/',
    method: 'GET'
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js